@use '@lib/assets/styles/main.scss' as *;

.root {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 8px;
  padding: 1px;
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-radius: 8px;
  }
  &[class*='blue'] {
    background: linear-gradient(180deg, $gray0 0%, $blue100 100%);
    box-shadow: 0 1px 3px rgba(30, 26, 199, 0.15);
    & > div {
      background: linear-gradient(225deg, $blue20 0%, $blueLight 100%);
    }
  }
  &[class*='yellow'] {
    background: linear-gradient(180deg, $gray0 0%, $warning100 100%);
    box-shadow: 0 1px 3px rgba(30, 26, 199, 0.15);
    & > div {
      background: linear-gradient(225deg, $gray0 0%, $warning200 100%);
    }
  }
  &[class*='red'] {
    background: linear-gradient(180deg, $gray0 0%, $error100 100%);
    box-shadow: 0 1px 3px rgba(30, 26, 199, 0.15);
    & > div {
      background: linear-gradient(225deg, $gray0 0%, $error200 100%);
    }
  }

  svg {
    display: block;
    width: 48px;
    height: auto;
  }
}
